import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { TerminosCondicionesResponseDto } from '../dto/auth/terminos-condiciones.dto';

@Injectable({
  providedIn: 'root',
})
export class TerminosCondicionesService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  obtenerTerminosYCondiciones(): Observable<TerminosCondicionesResponseDto> {
    const url = `${this.apiUrl}/terminos-condiciones`;
    return this.http.get<TerminosCondicionesResponseDto>(url);
  }
}
